import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatBotService } from './chat-bot.service';
import { ChatBotButtonComponent } from './chat-bot-button.component';
import { ChatBotComponent } from './chat-bot.component';
import { slideInOutAnimation } from './chat-bot-animations';

@Component({
  selector: 'app-chat-bot-wrapper',
  standalone: true,
  imports: [
    CommonModule,
    ChatBotButtonComponent,
    ChatBotComponent
  ],
  template: `
    <app-chat-bot-button></app-chat-bot-button>
    <app-chat-bot *ngIf="isVisible$ | async" @slideInOut></app-chat-bot>
  `,
  animations: [slideInOutAnimation]
})
export class ChatBotWrapperComponent   {
  isVisible$ = this.chatBotService.isVisible$;

  constructor(private chatBotService: ChatBotService) { }


}
